/* NILO V5.13.80 — Prix accessibles d'abord (affichage seulement).
   Compare les prix réels des variantes disponibles en centimes de MAD.
   Conserve l'ordre initial pour les prix identiques et les catégories d'origine.
   Ne modifie jamais panier, commande, API, variantes ou promotions. */
(function(){
 'use strict';
 if(window.NiloPricePriorityV51380)return;
 function cents(value){
  if(value===null||value===undefined||value==='')return Infinity;
  if(typeof value==='number')return Number.isFinite(value)&&value>0?(value>10000?Math.round(value):Math.round(value*100)):Infinity;
  var parsed=Number(String(value).replace(/[^0-9,.-]/g,'').replace(',','.'));
  return Number.isFinite(parsed)&&parsed>0?Math.round(parsed*100):Infinity;
 }
 function productPrice(product){
  var variants=product&&Array.isArray(product.variants)?product.variants:[];
  var active=variants.find(function(v){return v&&v.available!==false;})||variants[0];
  return cents(active&&active.price!==undefined?active.price:product&&product.price);
 }
 function cardPrice(node){
  var card=node&&node.matches&&node.matches('.nilo-product-card')?node:node&&node.querySelector&&node.querySelector('.nilo-product-card');
  var price=card&&Number(card.dataset.niloPrice||0);
  return Number.isFinite(price)&&price>0?price:Infinity;
 }
 function ordered(list,priceOf){
  return Array.from(list||[]).map(function(value,i){return{value:value,i:i,price:priceOf(value)};})
   .sort(function(a,b){return a.price-b.price||a.i-b.i;}).map(function(entry){return entry.value;});
 }
 function cards(list){return ordered(list,cardPrice);}
 function products(list){return ordered(list,productPrice);}
 // Intact explicit visitor sort (price descending, best selling, latest, filters).
 function collectionUrl(url){var u=new URL(url,location.href);if(!u.searchParams.has('sort_by'))u.searchParams.set('sort_by','price-ascending');return u;}
 window.NiloPricePriorityV51380={cards:cards,products:products,cardPrice:cardPrice,productPrice:productPrice,collectionUrl:collectionUrl};
})();
